import { Platform } from "@dndbeyond/event-pipeline-lib/shared";

/**
 * Returns the platform that events should be reported under. Touch devices
 * (coarse pointer) are reported as MobileWeb, matching how ddb-www detects it.
 * Falls back to Web when matchMedia isn't available.
 */
export const getPlatform = (): Platform =>
  globalThis.matchMedia?.("(pointer: coarse)").matches
    ? Platform.MobileWeb
    : Platform.Web;
